import React, {
    memo,
    useCallback,
    useContext,
    useEffect,
    useState,
} from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import FileExplorerContext from '../../../contexts/FileExplorerContext';
import { createFolder } from '../../../api/actions/Documents';
import { toast } from 'react-toastify';

const CreateFolderModal = ({ show, onClose }) => {
    const { onOpenFolder, fullPath, fetchFolderArchitecture } =
        useContext(FileExplorerContext);

    const [name, setName] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!show) {
            setName('');
        }
    }, [show]);

    const onCreateFolder = useCallback(
        async (event) => {
            event.preventDefault();
            if (isLoading || name.length === 0) {
                return;
            }

            setIsLoading(true);

            try {
                const currentFolder =
                    fullPath.length === 0
                        ? ''
                        : fullPath[fullPath.length - 1].id;

                await createFolder(currentFolder, name);
                onOpenFolder(currentFolder);
                fetchFolderArchitecture();
                onClose();
            } catch (error) {
                console.error(error);
                toast.error(
                    'Something went wrong while creating the folder. Please try again.',
                    {
                        className: 'custom-toast',
                    }
                );
            } finally {
                setIsLoading(false);
            }
        },
        [
            fullPath,
            name,
            onOpenFolder,
            isLoading,
            onClose,
            fetchFolderArchitecture,
        ]
    );

    const onNameChange = useCallback((event) => {
        const { value } = event.target;

        setName(value);
    }, []);

    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header closeButton>Create folder</Modal.Header>
            <Modal.Body>
                <Form onSubmit={onCreateFolder}>
                    <Form.Text>Folder name</Form.Text>
                    <Form.Control
                        name="name"
                        required
                        value={name}
                        onChange={onNameChange}
                        placeholder="Folder name"
                    />
                    <div className="d-flex justify-content-end mt-4">
                        <Button type="submit" disabled={name.length === 0}>
                            {isLoading ? <Spinner size="sm" /> : 'Create'}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default memo(CreateFolderModal);
